import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const InputTypeDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    state: 'detailed'
  }

  const emptyItem = {
    month: null,
    increase: null,
    increaseType: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData[props.field]})

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data)
    if(_.isArray(field)) {
      if(items[field[0]][field[1]] === val) return
      items[field[0]][field[1]] = val
    } else {
      _.set(newData, field, val)
    }
    setData(newData)
    let strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => {
      if (!item.increaseType) item.increaseType = props.defaults['increaseType']
    });
    _.set(newData, 'items', strippedItems)
    _.set(newData, 'state', 'detailed')

    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data)
    let strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => {
      if (!item.increaseType) item.increaseType = props.defaults['increaseType']
    });
    strippedItems.map((item, i) => item.year = i+1);
    _.set(newData, 'items', strippedItems)
    _.set(newData, 'state', 'detailed')

    props.persist(newData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setData(emptyRecord);
      setItems([{...emptyItem, i: 0}]);
    } else {
      setData({...props.rowData[props.field]});
    }
  }, [props['rowData']])

  const item_attrs = (field) => field_attrs('inflation', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      { renderItems.map((row:object, i) => (
        <MultiRowCarouselState_s className="carousel-multi-row detailed-row">
          <div>
            { i === 0 && <label>Month</label> }
            <NumberInput className="automated month" attrs={item_attrs} field={[`${row['i']}`, 'month']} {...params} min={0} readPrecision={0} writePrecision={0} />
          </div>
          <div>
            { i === 0 && <label>Increase</label> }
            <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'increase']} {...params} readPrecision={4} writePrecision={4} />
          </div>
          <div>
          { i === 0 && <label>Increase Type</label> }
            <DropdownInput className="automated increase-type" attrs={item_attrs} field={[`${row['i']}`, 'increaseType']} {...params} default={props.defaults['increaseType']} options={['% Increase', '% Increase Annually', '% of Market', '% of Market Annually', '/Area/Mo', '/Area/Yr', '/Area/Yr Annually', '/Mo', '/Yr']} />
          </div>
          <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
        </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default InputTypeDetailed
